import React, { useEffect, useState } from "react";
import "./CartItem.css";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

const CartItem = ({
  item,
  onIncrease,
  onDecrease,
  onRemove,
  onDiscountChange,
}) => {
  const [couponCode, setCouponCode] = useState("");
  const [discountAmount, setDiscountAmount] = useState(0);
  const [loading, setLoading] = useState(false); // Loader state
  const discountDynamicPrice = (item.price - discountAmount) * item.quantity;

  // Load coupon details from localStorage on component mount
  useEffect(() => {
    const savedCoupon = JSON.parse(localStorage.getItem(`coupon_${item._id}_${item.size}`));
    if (savedCoupon) {
      setCouponCode(savedCoupon.code);
      setDiscountAmount(savedCoupon.discount);
      onDiscountChange(item._id, item.size, savedCoupon.discount, savedCoupon.code);
    }
  }, []);

  const applyCouponCode = async () => {
    try {
      const response = await fetch(`https://riymay.com/api/v1/user/product/coupon/validator`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          couponCode,
          productId: item._id, 
        }),
      });

      if (!response.ok) {
        const errorMessage = await response.json();
        // alert();
        // Swal.fire(errorMessage.reason)
        toast.warning("Please Enter Coupon Code...", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          className: "custom-toast",
          bodyClassName: "custom-toast-body",
          toastId: "addedToCartno", })

        
        throw new Error("Failed to apply coupon" || errorMessage.reason);
      }

      const result = await response.json();
      // alert(result.reason);
      // Swal.fire(result.reason);

      toast.success(result.reason, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              className: "custom-toast",
              bodyClassName: "custom-toast-body",
              toastId: "addedToCart", })

      setDiscountAmount(result.discountAmount);
      onDiscountChange(item._id, item.size, result.discountAmount, couponCode);

      // Persist coupon code and discount amount in localStorage
      localStorage.setItem(
        `coupon_${item._id}_${item.size}`,
        JSON.stringify({ code: couponCode, discount: result.discountAmount })
      );
    } catch (err) {
      console.error(err);
    }
  };


  const removeCoupon = async () => {
    try {
      const response = await fetch(
        `https://riymay.com/api/v1/user/product/coupon/validator/${item._id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to remove coupon");
      }

      toast.warning("Coupon Removed Successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        className: "custom-toast",
        bodyClassName: "custom-toast-body",
        toastId: "addedTocoupenremoved", })
      ;
      
      setCouponCode("");
      setDiscountAmount(0);
      onDiscountChange(item._id, item.size, 0, "");

      localStorage.removeItem(`coupon_${item._id}_${item.size}`);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="cart-item">
      <button
        className="cart-item-remove-icon"
        onClick={() => onRemove(item._id, item.size)}
      >
        &times;
      </button>

      {/* <img
            src="../assets/rynobg.png" // Replace with the correct path to your logo
            alt="Logo"
            className="cart-item-logo"
          /> */}
      <img
        src={`https://riymay.com/assets/${item.images[0]?.url}`}
        alt={item.name}
        className="cart-item-image"
      />
      <div className="cart-item-details">
        <div className="cart-item-details-div-1">
          <h4 className="cart-item-name">
            {item.name.substring(0, 20)}
            {item.name.length > 20 && "..."}
          </h4>
          <p className="cart-item-price">₹ {discountDynamicPrice.toFixed(1)}</p>
          <p>
            Size: <span className="cart-item-size-3">{item.size}</span>
          </p>
          <p>
            {" "}
            Color:{" "}
            <span
              className="cart-item-color"
              style={{ backgroundColor: item.color || "green" }}
            ></span>
          </p>
          <p className="cart-item-stoc">
            Stock: {item.stockStatus ? "Available" : "no-stock"}
          </p>
        </div>
        <div className="cart-item-colors">
          <div className="cart-item-controls">
            <p>Quantity: </p>
            <div className="cart-item-controls-buttons">
              {" "}
              <button
                className="quantity-button decrease"
                onClick={() => onDecrease(item._id, item.size, item.color)}
                disabled={item.quantity <= 1}
              >
                -
              </button>
              <p className="cart-item-quantity">{item.quantity}</p>
              <button
                className="quantity-button increase"
                onClick={() => onIncrease(item._id, item.size, item.color)}
              >
                +
              </button>
            </div>
          </div>
          <div className="cart-item-coupon">
            <input
              type="text"
              placeholder="Enter coupon code"
              value={ couponCode || item.couponCode}
              onChange={(e) => setCouponCode(e.target.value)}
              className="cart-item-coupon-input"
            />

          {couponCode && (
            <button
              onClick={removeCoupon}
              className="cart-item-remove-coupon-button"
            >
              ✖
            </button>
          )}
            
            <button
              onClick={applyCouponCode}
              className="cart-item-apply-coupon-button"
            >
              Apply Coupon
            </button>
          </div>
        </div>


        {/* <button
        className="cart-item-remove-icon-mobile"
        onClick={() => onRemove(item._id, item.size, item.color)}
      >
     
        remove
      </button> */}
      </div>
    </div>
  );
};

export default CartItem;
